import WidgetRegistrySingleton from "ievv_jsbase/lib/widget/WidgetRegistrySingleton";
import LoggerSingleton from "ievv_jsbase/lib/log/LoggerSingleton";
import LOGLEVEL from "ievv_jsbase/lib/log/loglevel";
import SchoolSearchSelect from "./widgets/SchoolSearchSelect.js";

// Set the default loglevel
const logger = new LoggerSingleton();
logger.setDefaultLogLevel(LOGLEVEL.INFO);


// Get an instance of the widget registry
const widgetRegistry = new WidgetRegistrySingleton();

// Register the cradmin widgets we are using
// widgetRegistry.registerWidgetClass('cradmin-menutoggle', MenuToggleWidget);
// widgetRegistry.registerWidgetClass('cradmin-toggleable-menu', ToggleableMenuWidget);
widgetRegistry.registerWidgetClass('school-search-select', SchoolSearchSelect);
// Register the project specific widgets
// widgetRegistry.registerWidgetClass('something', Something);


// Initalize the widgets
function _onDomReady() {
  // Initialize all widgets in document.body
  widgetRegistry.initializeAllWidgetsWithinElement(document.body);
}

if (document.readyState !== 'loading'){
  _onDomReady();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    _onDomReady();
  });
}



// WEBPACK FOOTER //
// ./source/flipclass_publicui.js